import { ILegalEntitySelectOption } from '@/sections/administrative/accounts/orders/hooks';
import { RHFAutocomplete } from '@components/forms/hook-form';
import { useTranslation } from 'react-i18next';

interface LegalEntityMultipleSelectProps {
  name?: string;
  label?: string;
  placeholder?: string;
  options: ILegalEntitySelectOption[];
  isLoading?: boolean;
  disabled?: boolean;
  onChange?: (event: any, newValue: any) => void;
}

export const LegalEntityMultipleSelect = ({
  name = 'legalEntities',
  label,
  placeholder,
  options,
  isLoading,
  disabled,
  onChange,
}: LegalEntityMultipleSelectProps) => {
  const { t } = useTranslation();

  return (
    <RHFAutocomplete
      disabled={disabled || isLoading}
      name={name}
      label={label || t('Legal Entity')}
      placeholder={placeholder || t('Select Legal Entity')}
      multiple
      options={options}
      onChange={onChange}
      isOptionEqualToValue={(option, value: ILegalEntitySelectOption | null) => {
        return value && option ? option._id === value._id : false;
      }}
      loading={isLoading}
    />
  );
};
